<template>
    <component
        :is="href ? 'a' : 'button'"
        class="ds-card-button"
        :href
        :target
        :type
    >
        <DsCard
            clickable
            variant="interactive"
        >
            <div class="flex max-w-full items-center justify-between gap-4">
                <div class="flex-1 overflow-hidden text-left">
                    <slot />
                </div>
                <DsIcon
                    class="flex-shrink-0 text-content-secondary"
                    icon="fa-solid fa-chevron-right"
                    size="sm"
                />
            </div>
        </DsCard>
    </component>
</template>

<script setup lang="ts">
import DsCard from '@/components/design-system/DsCard.vue';
import DsIcon from '@/components/design-system/DsIcon.vue';

export interface DsCardButtonProps {
    type?: HTMLButtonElement['type'];
    href?: HTMLAnchorElement['href'];
    target?: HTMLAnchorElement['target'];
}

withDefaults(defineProps<DsCardButtonProps>(), {
    type: 'button',
});

defineSlots<{
    default: () => void;
}>();
</script>

<style scoped lang="scss">
.ds-card-button {
    @apply w-full appearance-none border-none bg-transparent p-0 text-inherit no-underline;

    &:focus-visible {
        @apply outline-none;
    }
}
</style>
